import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const sharedCoreEn = {
  columns: {
    id: "ID",
    name: commonShortFieldLabels.name,
    code: commonShortFieldLabels.code,
    actions: "Actions",
    requestId: "Orchestration ID",
    status: commonShortNouns.status,
    latestTask: "Latest Task",
    relatedTaskCount: "Related Tasks",
    createdBy: commonShortFieldLabels.createdBy,
    createdAt: commonShortFieldLabels.createdAt,
    updatedBy: commonShortFieldLabels.updatedBy,
    updatedAt: commonShortFieldLabels.updatedAt,
    operator: "Operator",
    vmId: "VM ID",
    accessEndpoint: "Access Endpoint",
    destroyedAt: "Destroyed At",
    failureCode: "Failure Code",
  },
  values: {
    expired: "Expired",
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "Port Mapping",
    noAccessEndpoints: "No access endpoints",
    workspaceAccessOnly: "Only accessible from the runtime node",
    undefinedSource: "Undefined source",
    runtimePublicHost: "Runtime public host",
    runtimePublicHostHelp: "Host or address used when the control plane reverse-connects to node-runtime; runtime_base_url is derived from this value and runtime_addr.",
    providerTypeLocal: "Local",
    providerTypeCenter: "Asset Center",
    executionProviderTypeLocal: "Local Execution",
    executionProviderTypeCenter: "Execution Fabric",
    providerTypeLocalRuntime: "Local Runtime",
    providerKeyLocalRuntimeDocker: "Local Runtime Docker",
    providerKeyLocalRuntimeKvm: "Local Runtime KVM",
    providerKeyAliyunAckContainer: "Aliyun ACK Container",
    providerKeyAliyunEcsKvm: "Aliyun ECS KVM",
    providerKeyUnknown: "Undefined Provider",
    providerPhaseTargetBusiness: "Target State",
    providerPhaseTargetIdentity: "Integrated with Unified Identity",
    providerPhaseTargetAsset: "Integrated with Asset Center",
    providerPhaseTargetExecution: "Integrated with Execution Fabric",
    providerPhaseTransition: "Migration In Progress",
    providerPhaseLegacy: "Legacy Mode",
    providerPhaseDisabled: "Disabled",
  },
  legend: {
    retryableFailed: "Retryable failures",
  },
  forms: {
    imagePlaceholder: "Image name, for example ghcr.io/example/app:1.0.0",
    imageRequired: "Please enter an image name",
  },
  messages: {
    invalidPort: "Port must be an integer between 1 and 65535",
  },
  parameterFields: {
    item: "Parameter Field #{index}",
    name: "Field Name",
    label: "Display Label",
    type: "Field Type",
    options: "Options",
    optionsHint: "For example: a,b,c",
    required: "Required",
    sensitive: "Sensitive",
    description: "Description",
  },
  fields: {
    description: "Description",
  },
  applicationContract: {
    requiredParameterFieldName: "Please enter a parameter field name",
    addParameterField: "Add Parameter Field",
    actionItem: "Action #{index}",
    actionName: "Action Name",
    requiredActionName: "Please enter an action name",
    actionLabel: "Action Label",
    actionEntrypoint: "Action Entrypoint",
    actionOutputKey: "Output Key",
    actionDescription: "Action Description",
    addActionInputField: "Add Action Input Field",
    addActionItem: "Add Action",
    outputItem: "Output #{index}",
    outputKey: "Output Key",
    outputLabel: "Output Label",
    outputType: "Output Type",
    outputFromAction: "Source Action",
    outputDescription: "Output Description",
    addOutputItem: "Add Output",
  },
} as const;
